import { createMockListResponse as e } from "../../../helpers/CreateMockListResponse.js";
//#region src/resources/batch-answer/evaluations/BatchAnswerEvaluations.mocks.ts
var t = (e) => ({
	id: `batch-${e}`,
	name: `Batch Answer ${e}`,
	createdOn: "2021-01-01T00:00:00Z",
	createdBy: {
		userId: "user-Id",
		fullName: "Daniel Rosenfeld"
	},
	totalRuns: e + 1,
	queryPipeline: {
		id: `pipeline-${e}`,
		name: `Pipeline ${e}`
	},
	datasetSummary: {
		id: `dataset-${e}`,
		name: `Dataset ${e}`,
		totalQueries: 100 + e
	},
	facets: [],
	customContext: {},
	credentials: { type: "ANONYMOUS" },
	runsStatistics: [
		{
			startDate: "2021-01-01T00:00:00Z",
			answerRate: .5,
			isCompleted: !0
		},
		{
			startDate: "2021-02-01T00:00:00Z",
			answerRate: .6,
			isCompleted: !0
		},
		{
			startDate: "2021-03-01T00:00:00Z",
			answerRate: 1,
			isCompleted: !0
		},
		{
			startDate: "2021-04-01T00:00:00Z",
			answerRate: .1,
			isCompleted: !0
		},
		{
			startDate: "2021-05-01T00:00:00Z",
			answerRate: 0,
			isCompleted: !0
		}
	]
}), n = (n) => e(t, (e) => e.name.includes(n ?? "")), r = (e) => t(0), i = () => t(0);
//#endregion
export { i as createMockBatchAnswerGetResponse, t as createMockBatchAnswerItem, n as createMockBatchAnswerListResponse, r as createMockEvaluationCreationResponse };

//# sourceMappingURL=BatchAnswerEvaluations.mocks.js.map